import { render, staticRenderFns } from "./ReportsSplitView.vue?vue&type=template&id=204b9b1c"
import script from "./ReportsSplitView.vue?vue&type=script&lang=js"
export * from "./ReportsSplitView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports